import { InvoicePurchases } from 'constants/invoice';
import { useBottomSheet } from 'hooks/bottomSheet';
import React from 'react';
import { PriceFormat } from 'services/price';

import CreditCardIcon from '@assets/icons/credit-card.svg';

import {
  Container,
  Content,
  FilledButton,
  FilledButtonText,
  Footer,
  Header,
  InvoiceImage,
  Item,
  ItemTitle,
  ItemTitleContainer,
  ItemValue,
  ItemValueContainer,
  ItemValueSub,
  Subtitle,
  SubtitlePrice,
  SubtitleSymbol,
  Title
} from './styles';

interface InvoicePostingBottomSheetProps {
  data: InvoicePurchases;
}

const InvoicePostingBottomSheet: React.FC<InvoicePostingBottomSheetProps> = ({
  data
}) => {
  const { closeBottomSheet } = useBottomSheet();

  return (
    <Container>
      <Header>
        <InvoiceImage source={CreditCardIcon} />
        <Title>Valor de lançamento na fatura</Title>
        <Subtitle>
          <SubtitleSymbol>R$</SubtitleSymbol>
          <SubtitlePrice>{PriceFormat(data.priceReais)}</SubtitlePrice>
        </Subtitle>
      </Header>
      <Content>
        <Item border>
          <ItemTitleContainer>
            <ItemTitle>Identificação do serviço</ItemTitle>
          </ItemTitleContainer>
          <ItemValueContainer>
            <ItemValue ellipsizeMode="tail" numberOfLines={1}>
              {data.description}
            </ItemValue>
          </ItemValueContainer>
        </Item>
        <Item border>
          <ItemTitleContainer>
            <ItemTitle>Tipo de compra</ItemTitle>
          </ItemTitleContainer>
          <ItemValue>
            {data.origin === 'NATIONAL' && 'Nacional'}
            {data.origin === 'INTERNATIONAL' && 'Internacional'}
          </ItemValue>
        </Item>
        <Item border>
          <ItemTitleContainer>
            <ItemTitle>Data de lançamento</ItemTitle>
          </ItemTitleContainer>
          <ItemValue>{data.dateString}</ItemValue>
        </Item>
        {data.USDExchangeRate > 0 && (
          <Item border>
            <ItemTitleContainer>
              <ItemTitle>Dólar de conversão do dia</ItemTitle>
            </ItemTitleContainer>
            <ItemValue>R$ {PriceFormat(data.USDExchangeRate)}</ItemValue>
          </Item>
        )}
        <Item border>
          <ItemTitleContainer>
            <ItemTitle>Moeda local</ItemTitle>
          </ItemTitleContainer>
          <ItemValue>{data.currency}</ItemValue>
        </Item>
        <Item>
          <ItemTitleContainer>
            {data.howManyInstallments === 1 && (
              <ItemTitle>Pagamento único</ItemTitle>
            )}
            {data.howManyInstallments > 1 && (
              <ItemTitle>Pagamento parcelado</ItemTitle>
            )}
          </ItemTitleContainer>
          <ItemValueContainer>
            <ItemValue>
              {data.currentInstallment}/{data.howManyInstallments} - R${' '}
              {PriceFormat(data.priceReais)}
            </ItemValue>
            {data.howManyInstallments > 1 && data.origin === 'NATIONAL' && (
              <ItemValueSub>
                Total R$ {PriceFormat(data.fullPriceReais)}
              </ItemValueSub>
            )}
            {data.origin === 'INTERNATIONAL' && (
              <ItemValueSub>Total {data.fullPriceInternational}</ItemValueSub>
            )}
          </ItemValueContainer>
        </Item>
      </Content>
      <Footer>
        <FilledButton onPress={closeBottomSheet}>
          <FilledButtonText>Ok, entendi</FilledButtonText>
        </FilledButton>
      </Footer>
    </Container>
  );
};

export default InvoicePostingBottomSheet;
